import useSWR from 'swr'

import { apiInstance } from './apiInstance'

const fetcher = (url: string) => apiInstance.get(url).then((res) => res.data)

export const useUserInfo = (sessionId: string) => {
  const { data, error } = useSWR(sessionId ? `/userinfo?session_id=${sessionId}` : null, fetcher, {
    onErrorRetry: (error) => {
      // エラーでは再試行しない。
      if (error) return
    },
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })
  return { userInfoData: data?.data, userInfoErrorStatus: error?.response?.status }
}